<div class="checkout-addres-details">
    <div class="checkout-addres-details__container">
        <app-address-details
            class="checkout-addres-details__container-address-details"
            (onAddAdress)="setAddressInfos($event)"
            [mainAddress]="mainAddress"
        >
        </app-address-details>
    </div>
</div>